"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _login = require("@/api/login");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
var _default = exports.default = {
  name: 'App',
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  mounted: function mounted() {
    var themeConfig = JSON.parse(sessionStorage.getItem("themeConfig"));
    document.documentElement.style.setProperty("--tabbackground", themeConfig == null ? '#409EFF' : themeConfig.tabbackground);
    document.documentElement.style.setProperty("--tabfontcolor", themeConfig == null ? '#000' : themeConfig.tabfontcolor);
    document.documentElement.style.setProperty("--aside", themeConfig == null ? '#ecf5ff' : themeConfig.aside);

    // 在iframe中运行时，通知会员中心已就绪，并监听SSO登录消息
    if (window.self !== window.top) {
      window.parent.postMessage({
        type: 'OPERATION_READY'
      }, '*');
      window.addEventListener('message', this._handleSsoMessage);
      // 若已有token，直接通知父页面可以隐藏loading
      if ((0, _auth.getToken)()) {
        this.$nextTick(function () {
          window.parent.postMessage({
            type: 'MALL_APP_READY'
          }, '*');
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this._handleSsoMessage);
  },
  data: function data() {
    return {
      isRouterAlive: true,
      _ssoHandled: false
    };
  },
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    _handleSsoMessage: function _handleSsoMessage(event) {
      var _this = this;
      if (!event.data || event.data.type !== 'MEMBER_CENTER_INIT') return;
      if (this._ssoHandled) return;
      var _ref = event.data.data || {},
        jwtToken = _ref.jwtToken;
      if (!jwtToken) return;

      // 若已有有效token，无需重新登录
      if ((0, _auth.getToken)()) return;
      this._ssoHandled = true;
      (0, _login.ssoLogin)({
        jwtToken: jwtToken
      }).then(function (res) {
        if (res && res.data && res.data.token) {
          (0, _auth.setToken)(res.data.token);
          _this.$store.commit('user/SET_TOKEN', res.data.token);
          _this.$router.replace('/').catch(function () {});
          window.parent.postMessage({
            type: 'MALL_APP_READY'
          }, '*');
        } else {
          _this._ssoHandled = false;
        }
      }).catch(function () {
        _this._ssoHandled = false;
      });
    }
  }
};